import {getPrivateAxios} from '@blesk-frontend/api';

export interface AuthLoginData {
  email: string;
  staffId?: string;
  captchaToken: string | null;
}

/**
 *
 * @param data
 */
export const fetchAuthLogin = async (data: AuthLoginData) => {
  const response = await getPrivateAxios().post<void>('/auth/login', data);
  return response.data;
};
